


import React, { useState } from "react";
import "../../../App.css";
import "../../../pages/LeadDataReportMaster/LeadDataReportMaster.css"
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import ConvertedSalesOrder from "../../../components/ConvertedSalesOrder/ConvertedSalesOrder";
import "../../../pages/LeadDataReportMaster/LeadDataReportMaster.css";

const SalesOrder = () => {
    const [openProfile, setOpenProfile] = useState(false);
 
    return (
      <>
        <div className="d-flex flex-row app">
          <MiniDrawer />
         
          <div
            className="container-fluid"
            style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4", width: "100%", overflowX: "auto" }}
          >
            <div
              className="d-flex flex-column w-100"
              style={{ backgroundColor: "#F4F4F4" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "1%",
                }}
              >
                <div>
                  <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Converted Sales Report | <HomeOutlinedIcon />{" "}
                    <span style={{ fontSize: "20px" }}>&gt; Report</span>
                  </h1>
                </div>
                
              </div>
              <div> 
              <Wrapper className="ViewLeadDetails wrapperLeadDataReport" >                 
                  <ConvertedSalesOrder                  
                    setOpenProfile={setOpenProfile}
                    openProfile={openProfile}
                  />                
                </Wrapper>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}

export default SalesOrder;